<template>
  <div class="col-span-12">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12 mx-auto mt-4">
        <table class="w-full leading-normal text-blue-dark"
               style="border: solid 1px #dedede;">
          <thead class="bg-primary-pale" >
          <tr>
            <th colspan="12" class="py-2">
              <span class="px-2">Members</span>
            </th>
          </tr>
          </thead>
          <tbody>
            <MemberDetails v-for="(member,idx) in members" :member="member" :key="idx" class="mt-2 mb-4 px-2 py-2 border-b border-gray"/>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import MemberDetails
  from "@/domains/home/services/registry/business/files/tabs/building_society_data/MemberDetails.vue";

defineProps<{ members: any[] }>();
</script>

